<template>
  <div>
    <div class="d-flex justify-center align-center" v-if="isLoading">
      <v-progress-circular indeterminate :size="70" :width="7" color="purple" />
    </div>
    <template v-else>
      <GChart :type="type" :data="chartData" :options="options"
    /></template>
  </div>
</template>

<script>
  import { GChart } from 'vue-google-charts/legacy'
  import { mapActions } from 'vuex'
  export default {
    components: {
      GChart
    },
    props: {
      startDate: {
        type: String
      },
      endDate: {
        type: String
      }
    },
    data() {
      return {
        type: 'PieChart',
        isLoading: true,
        options: {
          colors: ['blue', 'orange', 'red', 'green', 'pink', 'grey'],
          title: 'Systems',
          height: 300,
          animation: { startup: true, duration: 500 },
          legend: { position: 'bottom' }
        }
      }
    },
    computed: {
      consumersBySystemPie() {
        return this.$store.state.analytics.consumersBySystemPie
      },
      chartData() {
        const data = [['System', 'Count']]
        for (const key in this.consumersBySystemPie) {
          if (key !== 'total') {
            data.push([key, this.consumersBySystemPie[key]])
          }
        }

        return data
      }
    },
    methods: {
      ...mapActions(['fetchConsumersBySystemPie'])
    },
    watch: {
      async startDate(newValue, oldValue) {
        this.isLoading = true

        await this.fetchConsumersBySystemPie({
          startDate: this.startDate,
          endDate: this.endDate
        })
        this.isLoading = false
      },
      async endDate(newValue, oldValue) {
        this.isLoading = true

        await this.fetchConsumersBySystemPie({
          startDate: this.startDate,
          endDate: this.endDate
        })
        this.isLoading = false
      }
    },
    async created() {
      await this.fetchConsumersBySystemPie({
        startDate: this.startDate,
        endDate: this.endDate
      })
      this.isLoading = false
    }
  }
</script>

<style lang="scss" scoped></style>
